import React from "react";
import { IconT } from "types/utils";

type CheckIconPropsT = IconT & {
  backgroundFill?: string;
};

const CheckIcon = ({
  backgroundFill = "none",
  fill = "var(--eggplant)",
  height = "24",
  width = "25",
}: CheckIconPropsT) => {
  return (
    <svg width={width} height={height} viewBox="0 0 25 24" fill={backgroundFill} xmlns="http://www.w3.org/2000/svg">
      <circle cx="12.7363" cy="12" r="10.925" stroke={fill} strokeWidth="2.15" />
      <rect
        x="8.9043"
        y="10.8359"
        width="6"
        height="2.4"
        rx="0.5"
        transform="rotate(42.6057 8.9043 10.8359)"
        fill={fill}
      />
      <rect
        x="18.1943"
        y="9.59375"
        width="9.6"
        height="2.4"
        rx="0.5"
        transform="rotate(132.606 18.1943 9.59375)"
        fill={fill}
      />
    </svg>
  );
};

export default CheckIcon;
